import actions from '@/store/orders/actions';

const ordersModule = {
  state: () => ({
    orders: [],
    total: 0,
  }),
  getters: {
    sortedOrders(state) {
      return state.orders ? state.orders.sort((a, b) => b.id - a.id) : [];
    },
  },
  mutations: {
    GET_ORDERS_SUCCESS(state, data) {
      state.orders = data;
    },
    SET_ORDERS_TOTAL(state, total) {
      state.total = total;
    },
  },
  actions,
  namespaced: true,
};

export default ordersModule;
